import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

import {
  PHARMACY_PRODUCT_TYPE,
  PHARMACY_SALE_MODE,
  RECEIPT_MODE,
  PHARMACY_TAX_TYPE,
} from '../../../../../constants/dropdown';
import { GeneralDetailForm } from './GeneralDetailForm';
import { dateFormatter } from '../../../../../utils';
import { AddProductDetailsForm } from './AddProductDetailsForm';
import axios from 'axios';

const TAX_HEADER = [
  { header: 'GST%', accessor: 'gst' || 0 },
  { header: 'Taxable Amount', accessor: 'bill_amount' || 0 },
  { header: 'CGST Amt', accessor: 'cgst' || 0 },
  { header: 'SGST Amt', accessor: 'sgst' || 0 }
];

const POS_HEADER = [
  {
    header: 'Pos No.',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.inv_no}`}
        </span>
      );
    }
  },
  { header: 'Date', accessor: 'createdAt' },
  { header: 'Product Type', accessor: 'product_type' },
  { header: 'Sale Mode', accessor: 'sale_mode' },
  { header: 'Patient Name', accessor: 'patient_name' },
  { header: 'Uhid', accessor: 'uhid' },
  { header: 'Ipd', accessor: 'ipd_no' },
  { header: 'Paymode', accessor: 'pay_mode' },
  {
    header: 'Ledger',
    accessor: (row) => row?.ledger?.ledger_name
  },
  { header: 'Net Amount', accessor: 'bill_amount' },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
];

const OPD_PATIENT_TABLE_COLUMNS = [
  { header: 'Uhid', accessor: (row) => row?.uhid },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name} ` },
  { header: 'Mobile No', accessor: (row) => row?.address?.mobile },
  { header: 'Doctor', accessor: (row) => row?.consultant?.name },
  { header: 'Sponsor', accessor: (row) => row?.sponsor?.name },
  { header: 'Address', accessor: (row) => row?.address?.address },
  { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) }
];

const IPD_TABLE_COLUMNS = [
  { header: 'Ipd No', accessor: (row) => row?.ipd_no },
  { header: 'Patient Name', accessor: (row) => row?.patient?.name },
  { header: 'Mobile No', accessor: (row) => row?.patient?.mobile },
  { header: 'Doctor', accessor: (row) => row?.consultant_detail?.doctor?.name },
  { header: 'Address', accessor: (row) => row?.patient?.address },
  { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) }
];

const initialPatientDataObj = {
  data: [],
  loading: false
};
const initialPosDataObj = {
  data: [],
  loading: false
};
export const RetailSalePOS = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [retailSalePosObj, setRetailSalePosObj] = useState(initialPosDataObj);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [warehouse, setWareHosue] = useState([]);
  const [opdDialogueOpen, setOpdDialogueOpen] = useState(false);
  const [ipdDialogueOpen, setIpdDialogueOpen] = useState(false);
  const [generalDialogueOpen, setGeneralDialogueOpen] = useState(false);
  const [accountLedger, setAccountLedger] = useState([]);
  const [patientDetail, setPatientDetail] = useState([]);
  const [opdPatientDetail, setOpdPatientDetail] = useState([]);
  const [ipdPatientDetail, setIpdPatientDetail] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  // const [qty, setQty] = useState('');
  const [opdData, setOpdData] = useState([]);
  const [ipdData, setIpdData] = useState([]);
  const [posInput, setPosInput] = useState('');
  const [opdInput, setOpdInput] = useState('');
  const [ipdInput, setIpdInput] = useState('');
  const [taxTableData, setTaxTableData] = useState([{ gst: 0, bill_amount: 0, cgst: 0, sgst: 0 }]);
  const [productStocks, setProductStocks] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [posData, setPosData] = useState([]);
  const [opdFilterData, setOpdFilterData] = useState({ data: [] });
  const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
  const [stock, setStock] = useState([]);
  const [editData, setEditData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [selectedrowData, setSelectedRowData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [selectedLedger, setSelectedLedger] = useState([]);
  const [productRemaining, setProductRemaining] = useState(0);

  const productRef = useRef();
  const billAmountRef = useRef(null);
  const gstAmountRef = useRef(null);
  const cgstAmountRef = useRef(null);
  const sgstAmountRef = useRef(null);
  const updatedTableData = taxTableData.map((row) => ({
    ...row,
    bill_amount: billAmountRef.current ? billAmountRef.current.value : 0,
    gst: gstAmountRef.current ? gstAmountRef.current.value : 0,
    cgst: cgstAmountRef.current ? cgstAmountRef.current.value : 0,
    sgst: sgstAmountRef.current ? sgstAmountRef.current.value : 0
  }));

  const [productStock, setProductStock] = useState([]);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        ledger: Yup.string().required(' '),
        pay_mode: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      product_type: 'pharmacy product',
      bill: {
        out_sourced: 'No',
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const qty = watch('Qty');

  const PRODUCT_HEADER = [{ header: 'Product', accessor: (row) => row?.product?.main?.name }];

  useEffect(() => {
    let total_amount = 0;
    let bill_amount = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;
    let gst = 0;
    const gstValue = tableData.length > 0 ? tableData[tableData.length - 1].gst : 0;
    tableData.forEach((detail) => {
      const amount = detail.mrp * detail.bill_qty;
      bill_amount += amount;
      total_amount += amount;
      total_amt += amount;
    });
    const roundedNetAmt = Math.round(net_amt);
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));
    setValue(
      'total_qty',
      tableData.reduce((acc, curr) => acc + curr.bill_qty, 0)
    );
    setValue('total_amt', total_amt);
    setValue('gst', gstValue);
    setValue('bill_amount', bill_amount);
    setValue('disc_amt', disc_amt);
    setValue('gst_amt', gst_amt);
    setValue('net_amt', roundedNetAmt);
    setValue('round_off', Math.abs(roundOff));
  }, [detailList, setValue, tableData]);
  const TotalAmount = watch('total_amt');
  const DisPercent = watch('dis_per');
  const DisAmt = watch('dis_amount');
  const recAmt1Watch = watch('recpt_1');
  const recAmt2Watch = watch('recpt_2');
  const taxable = watch('bill_amount');
  const gstPer = watch('gst');
  const cgst = watch('cgst');
  const sgst = watch('sgst');
  useEffect(() => {
    const calculatedDisAmt = (TotalAmount * (DisPercent / 100) || 0).toFixed(2);
    const calculateBillamt = (TotalAmount - calculatedDisAmt).toFixed(2);
    const calculatesgst = (taxable * (gstPer / 100) || 0).toFixed(2);
    console.log('calculated SGST:', calculatesgst);
    setValue('dis_amount', parseFloat(calculatedDisAmt));
    setValue('bill_amount', parseFloat(calculateBillamt) || 0);
    const total_recpt = (parseFloat(recAmt1Watch) || 0) + (parseFloat(recAmt2Watch) || 0);
    setValue('total_recpt', total_recpt.toFixed(2));
    const amountAfterDiscount = TotalAmount - parseFloat(calculatedDisAmt);
    const balanceAmt = amountAfterDiscount - total_recpt;
    setValue('balance', balanceAmt.toFixed(2));
    setValue('cgst', (parseFloat(calculatesgst) / 2).toFixed(2));
    setValue('sgst', (parseFloat(calculatesgst) / 2).toFixed(2));
  }, [TotalAmount, DisPercent, recAmt1Watch, recAmt2Watch, setValue]);

  const netAmtWatch = watch('total_amt');
  const payMode = watch('pay_mode');
  console.log('HELLLO PAY MODE', payMode);

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(() => {
    getAccountLedgerData();
  }, [getAccountLedgerData]);

  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;

    if (payMode === 'CASH') {
      setValue('recpt_1', netAmtWatch);
      setValue('recpt_2', 0);
      setValue('balance_amt', 0);
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('recpt_1', 0);
      setValue('recpt_2', netAmtWatch);
      setValue('balance', 0);
    } else if (payMode === 'Credit') {
      setValue('recpt_1', 0);
      setValue('recpt_2', 0);
      setValue('balance', balanceAmt);
    } else {
      setValue('balance', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);
  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'productDetails',
        'taxDetails',
        'uhid',
        'cgst',
        'sgst'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setTableData(selectedRecord?.productDetails);
      setValue('inv_no', selectedRecord?.inv_no);
      setValue('pay_mode', selectedRecord?.pay_mode);
      setValue('ledger', selectedRecord?.ledger);
      setValue('tax_type', selectedRecord?.tax_type);
      setValue('sale_mode', selectedRecord?.sale_mode);
      setValue('recpt_1', selectedRecord?.recpt_1);
      setValue('recpt_2', selectedRecord?.recpt_2);
      setValue('dis_per', selectedRecord?.dis_per);
      setValue('type', selectedRecord?.type);
      setValue('location', selectedRecord?.location?._id);
      setValue('product_type', selectedRecord?.product_type);
      setValue('remarks', selectedRecord?.remarks);
      setValue('cgst', selectedRecord?.cgst);
      setValue('sgst', selectedRecord?.sgst);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    if (tableData.length === 0) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }
    if (opdPatientDetail.length === 0 && ipdPatientDetail.length === 0 && patientDetail.length === 0) {
      toast('Please Add the Patient First', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const patientDetails = {
      patient_name:
        opdPatientDetail?.first_name ||
        ipdPatientDetail?.patient?.name ||
        (Array.isArray(patientDetail) && patientDetail.length > 0 ? patientDetail[0].patient_name : ''),
      uhid: opdPatientDetail?.uhid || ipdPatientDetail?.uhid,
      doctor_name:
        opdPatientDetail?.consultant?.name ||
        ipdPatientDetail?.consultant_detail?.doctor?.name ||
        (Array.isArray(patientDetail) && patientDetail.length > 0 ? patientDetail[0].doctor?.name : ''),
      ipd_no: ipdPatientDetail?.ipd_no
    };
    const productData = tableData.map((row) => ({
      ...row,
      product: row?.product._id || row?.product,
      amount: row.mrp * row.bill_qty
    }));
    const payload = {
      ...formValues,
      productDetails: productData,
      taxDetails: updatedTableData,
      ...patientDetails
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/retail-sale-update' : '/retail-sale-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });

    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Retail Sale POS`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Retail Sale POS`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRetailSalePosObj({ loading: true });
    const response = await request('/retail-sale-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      const sortedData = filteredData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setRetailSalePosObj({ loading: false, data: sortedData });
      setPosData({ data: sortedData });
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setRetailSalePosObj({ loading: false });
    }
  };

  const handleRowDelete = (rowId) => {
    console.log('HELLLO ROW ID', rowId);
    setTableData((prev) =>
      prev.filter((data) => {
        console.log(data, 'HELLO DATA JIIIIW');
        return data._id !== rowId;
      })
    );
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (productStock && productStock.length > 0) {
      setOriginalData(productStock);
      setIsFiltered(false);
    }
  }, [productStock]);

  useEffect(() => {
    handleProductSearch(input);
  }, [input]);

  const handleProductSearch = (searchValue) => {
    const lowercasedInput = searchValue.toLowerCase();
    const filtered = productStock.filter((item) =>
      item.product?.main?.name?.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  const getStockDropdown = useCallback(async () => {
    try {
      const data = await dropdownFetch('stock-master');
      const uniqueProductMap = new Map();
      const filteredProducts = data.flatMap((item) =>
        item.productDetails.filter((detail) => {
          const productId = detail.product._id;
          if (!uniqueProductMap.has(productId)) {
            uniqueProductMap.set(productId, true);
            return true;
          }
          return false;
        })
      );

      setProductStock(filteredProducts);
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  }, []);

  useEffect(() => {
    getLocationDropdown();
    getStockDropdown();
  }, [getStockDropdown, getLocationDropdown]);

  const handleRowClick = (row) => {
    console.log('HELLLO THIS IS THE ROW', row);
    setSelectedRow(row);
    setValue('product', row?.product?.main?.name);
    setProductStocks(row?.total_qty);
    setSelectedRowData(row?.product?._id);
    fetchStocks(row?.product?._id);
  };
  // const handleQtyChange = (e) => {
  //   setQty(e.target.value);
  // };
  const fetchOpdPatients = async () => {
    setOpdDialogueOpen(true);
    setPatientDataObj({ loading: true });
    try {
      const response = await request('/patient-registeration-list', { method: 'GET' });
      if (response.success) {
        const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPatientDataObj({ loading: false, data: sortedData });
        setOpdData(sortedData);
        setOpdFilterData(sortedData);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const fetchIpdPatient = async () => {
    setIpdDialogueOpen(true);
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response?.data
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdData(filteredData);
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  const saleMode = watch('sale_mode');
  const handleOpdPatient = (row) => {
    setOpdPatientDetail(row);
    console.log('HELLO OPD PATEINT DETAILS', opdPatientDetail);
    setOpdDialogueOpen(false);
  };

  const handleIpdRow = (row) => {
    setIpdPatientDetail(row);
    console.log('HELLO IPD PATEINT DETAILS', ipdPatientDetail);
    setIpdDialogueOpen(false);
  };

  const fetchStock = async () => {
    const response = await request('/stock-master-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      console.log(sortedData, ' this is stock');
      setStock({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setStock({ loading: false });
    }
  };
  useEffect(() => {
    if (['new'].includes(currentAction)) {
      fetchStock();
    }
  }, [currentAction]);

  const handleAdd = () => {
    if (!selectedRow) return;
    const flattenedStock = stock.data.flatMap((item) =>
      item.productDetails.map((detail) => ({
        ...detail,
        createdBy: item.createdBy,
        createdAt: item.createdAt
      }))
    );
    const matchingProducts = flattenedStock.filter((product) => product.product?._id === selectedRow?.product?._id);
    if (matchingProducts.length === 0) {
      toast('No matching product found for the selected row.', { variant: 'warning' });
      return;
    }
    // Sort matching products by `exp_date` and pick the nearest one
    const nearestExpDateProduct = matchingProducts.sort((a, b) => new Date(a.exp_date) - new Date(b.exp_date))[0];
    console.log('Nearest Exp Date Product:', nearestExpDateProduct);
    // Create the updated row with `bill_qty`
    const updatedRow = {
      ...nearestExpDateProduct,
      bill_qty: qty
    };
    // Update the table data
    const updatedTableData = tableData.some((row) => row._id === nearestExpDateProduct._id)
      ? tableData.map((row) => (row._id === nearestExpDateProduct._id ? updatedRow : row))
      : [...tableData, updatedRow];
    // Update the state
    if (qty === '') {
      return;
    }
    setTableData(updatedTableData);
    // setQty('');
    setSelectedRow(null);
    // Refocus the product input
    if (productRef.current) {
      productRef.current.focus();
    }
  };

  useEffect(() => {
    if (productRef.current) {
      productRef.current.focus();
    }
  }, []);

  const productData = tableData.map((row) => ({
    ...row,
    amount: row.mrp * row.bill_qty
  }));

  const PRODUCT_TABLE_HEADER = [
    { header: 'Product Name', accessor: (row) => row?.product?.main?.name || row?.product_name },
    { header: 'Bill Qty', accessor: 'bill_qty' },
    { header: 'MRP', accessor: 'mrp' },
    {
      header: 'Amount',
      accessor: (row) => row?.amount
    },
    { header: 'Batch No', accessor: 'batch_no' },
    { header: 'Gst', accessor: 'gst' },
    { header: 'Exp Date', accessor: (row) => formatDateToMonthYear(row?.exp_date) }
  ];

  useEffect(() => {
    if (retailSalePosObj && retailSalePosObj.length > 0) {
      setPosData(retailSalePosObj);
      setIsFiltered(false);
    }
  }, [retailSalePosObj]);


  useEffect(()=>{
    handlePosSearch()
  },[posInput])

  const handlePosSearch = async () => {
    const lowercasedInput = posInput.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/retail-sale-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPosData({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPosData({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPosData({ loading: false, data: [] });
    }
  };

  const handleChangePos = (e) => {
    const newInput = e.target.value;
    setPosInput(newInput);
  };

  useEffect(() => {
    if (opdData && opdData.length > 0) {
      setOpdFilterData({ data: opdData });
      setIsFiltered(false);
    }
  }, [opdData]);

  useEffect(()=>{
    handleOpdDataFilter()
  },[opdInput])

  const handleOpdDataFilter = async () => {
    setPatientDataObj({ loading: true });
    try {
      const lowercasedInput = opdInput.toLowerCase().trim();
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/patient-registeration-list', { method: 'GET', query: query });
      if (response.success) {
        const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPatientDataObj({ loading: false, data: sortedData });
        setOpdData(sortedData);
        setOpdFilterData(sortedData);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const handleOpdChange = (e) => {
    const newInput = e.target.value;
    setOpdInput(newInput);
  };

  useEffect(() => {
    if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
      setIpdFilterData({ data: indoorRegisterationDataObj.data});
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj]);

  useEffect(()=>{
    handleIpdDataFilter()
  },[ipdInput])

  const handleIpdDataFilter = async () => {
    setIndoorRegisterationDataObj({ loading: true });
    const lowercasedInput = ipdInput.toLowerCase().trim();
    const query = {};
    if (lowercasedInput) {
      query.name = lowercasedInput;
    }
    const response = await request('/indoor-registeration-list', { method: 'GET', query : query});
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter((item) => item.admission_status === 'admit');
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdData(sortedData);
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };
  
  const handleIpdChange = (e) => {
    const newInput = e.target.value;
    setIpdInput(newInput);
  };

  function formatDateToMonthYear(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long' };
    return date.toLocaleDateString('en-US', options);
  }

  const handleRowEdit = (row) => {
    setAddDetailsDialogOpen(true);
    setEditData(row);
    setIsEditMode(true);
  };

  useEffect(() => {
    console.log('HELLLO THE TABLE DATA IS HERE', tableData);
  }, [tableData]);

  const onDetailAddHandler = (data) => {
    console.log('Existing Table Data: ', tableData);
    console.log('Incoming Data: ', data);
    setTableData((prev) => {
      const incomingProductId = data.product._id || data.product;
      console.log('Incoming Product ID: ', incomingProductId);
      const existingRowIndex = prev.findIndex((item) => item.product._id === incomingProductId);
      console.log('Existing Row Index: ', existingRowIndex);
      if (existingRowIndex >= 0) {
        console.log('Updating existing row with product._id:', incomingProductId);
        return prev.map((item, index) => {
          if (index === existingRowIndex) {
            return { ...item, ...data };
          }
          return item;
        });
      } else {
        return [
          ...prev,
          {
            ...data
          }
        ];
      }
    });
  };

  const calculateTotalQty = () => {
    const flattenedProductDetails = stock?.data?.flatMap((stockItem) => stockItem.productDetails);
    const matchedProducts = flattenedProductDetails?.filter(
      (productDetail) => productDetail.product._id === selectedrowData
    );
    const totalBillQty = matchedProducts?.reduce((acc, productDetail) => acc + Number(productDetail.total_qty), 0);
    setTotalQty(totalBillQty);
  };
  useEffect(() => {
    calculateTotalQty();
  }, [stock, selectedrowData]);

  useEffect(() => {
    if (payMode) {
      let selected;

      // If the payMode is 'Cash', find the ledger with 'Cash' in the ledger_name
      if (payMode.toLowerCase() === 'cash') {
        selected = accountLedger.find((ledger) => ledger.ledger_name.toLowerCase() === 'cash');
      }

      // If the payMode is 'Bank', find the ledger that includes 'Bank' in the ledger_name
      else if (payMode.toLowerCase() === 'bank') {
        selected = accountLedger.find((ledger) => ledger.ledger_name.toLowerCase().includes('bank'));
      } else if (payMode.toLowerCase() === 'credit') {
        selected = accountLedger.find((ledger) => ledger.ledger_name.toLowerCase().includes('credit'));
      }
      // If a ledger is found, set it to the form field using setValue
      setValue('ledger', selected?._id);
    }
  }, [payMode, accountLedger, setValue]);

  const fetchStocks = async (rowId) => {
    const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
    if (response?.data?.success) {
      const totalQuantity = response.data.data;
      const totalQuantitySum = totalQuantity.reduce((sum, item) => sum + item.totalQuantity, 0);
      setProductRemaining(totalQuantitySum);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setProductRemaining({ loading: false, data: [] });
    }
  };

  console.log('HELLLO PRODUCT REMAINING', productRemaining);
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                POS
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    setTableData([]);
                    setPatientDetail([]);
                    setOpdPatientDetail([]);
                    setIpdPatientDetail([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Location </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6
                      }}
                      name="location"
                      menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6
                      }}
                      name="product_type"
                      menus={PHARMACY_PRODUCT_TYPE}
                    />
                  </Stack>

                  <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: '1%' }}>
                    <Stack direction="row" alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '14px',
                            fontWeight: '700'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px'
                          }
                        }}
                        label="Search Product Name"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                        inputRef={productRef}
                      />
                    </Stack>
                    <Table
                      containerSX={{
                        flex: 1,
                        maxHeight: '400px'
                      }}
                      data={
                        currentAction === 'new'
                          ? originalData.map((data) => ({
                              _id: data._id,
                              ...data,
                              ...data.productDetails
                            }))
                          : []
                      }
                      columns={PRODUCT_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        handleRowClick(row);
                      }}
                      sx={{
                        '& .MuiTableCell-root': {
                          fontSize: '1.4rem',
                          padding: '3px'
                        },
                        '& .MuiTableCell-head': {
                          fontSize: '1.4rem',
                          fontWeight: 'bold'
                        },
                        '& .MuiTableRow-root': {}
                      }}
                    />
                  </Grid>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '6rem' }}>
                    <Table
                      containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                      data={updatedTableData || []}
                      columns={TAX_HEADER}
                      size="small"
                    />
                  </Grid>
                </Grid>

                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <>
                    <>
                      {Array.isArray(patientDetail) &&
                        patientDetail.map((item, index) => (
                          <div style={{ display: 'flex', justifyContent: 'space-between' }} key={index}>
                            <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                              Patient Name :- {item.patient_name}
                            </Typography>
                            <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                              Doctor :- {item.doctor?.name}
                            </Typography>
                          </div>
                        ))}
                      {opdPatientDetail?.first_name && opdPatientDetail?.consultant?.name && (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Patient Name :-{' '}
                            {`${opdPatientDetail?.name_suffix || ''} ${opdPatientDetail?.first_name || ''} ${opdPatientDetail?.last_name || ''}`}
                          </Typography>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Doctor :- {opdPatientDetail?.consultant?.name}
                          </Typography>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            uhid :- {opdPatientDetail?.uhid}
                          </Typography>
                        </div>
                      )}
                      {/* Render ipdPatientDetail if it exists and has valid patient and doctor details */}
                      {ipdPatientDetail?.patient?.name && ipdPatientDetail?.consultant_detail?.doctor?.name && (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Patient Name :- {ipdPatientDetail?.patient?.name}
                          </Typography>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Ipd No :- {ipdPatientDetail?.ipd_no}
                          </Typography>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Uhid No :- {ipdPatientDetail?.uhid}
                          </Typography>
                          <Typography sx={{ color: 'red', fontWeight: 700, fontSize: '1.4rem' }}>
                            Doctor :- {ipdPatientDetail?.consultant_detail?.doctor?.name}
                          </Typography>
                        </div>
                      )}
                    </>
                  </>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Pay Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.5 }}
                      name="pay_mode"
                      placeholder="Pay Mode"
                      menus={RECEIPT_MODE}
                    />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.5 }}
                      name="remarks"
                      placeholder="Enter Remarks"
                    />
                  </Stack>

                  <Stack
                    sx={{
                      border: '1px solid grey',
                      padding: '5px',
                      borderRadius: '5px',
                      boxShadow: '0px 2px 2px #0099ff'
                    }}
                    spacing={0.5}
                    direction="column"
                  >
                    {/* First Row of Inputs */}
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Sale Mode</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="sale_mode"
                        placeholder="Sale Mode"
                        menus={PHARMACY_SALE_MODE}
                      />
                      <Button
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.1, minWidth: 0.15, p: 0.25, height: '100%' }}
                        variant="contained"
                        onClick={() => {
                          if (saleMode === 'OPD') {
                            setOpdDialogueOpen(true) || fetchOpdPatients();
                          } else if (saleMode === 'IPD') {
                            setIpdDialogueOpen(true) || fetchIpdPatient();
                          } else if (saleMode === 'GENERAL') {
                            setGeneralDialogueOpen(true);
                          }
                        }}
                      >
                        Patient Details
                      </Button>

                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Inv No.</Typography>
                      <TextField disabled sx={{ flex: 0.3 }} name="inv_no" placeholder="Inv No." />

                      <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Inv Date</Typography>
                      <TextField disabled sx={{ flex: 0.3 }} name="date" placeholder="Inv Date" />
                    </Stack>
                    {/* Second Row of Inputs (Same as the First) */}
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Ledger</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 1 }}
                        name="ledger"
                        placeholder="Ledger"
                        menus={accountLedger.map((data) => ({
                          ...data,
                          name: data.ledger_name
                        }))}
                      />

                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Tax Type</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.3 }}
                        name="tax_type"
                        placeholder="Tax Type"
                        menus={PHARMACY_TAX_TYPE}
                      />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', flex: 0.11 }}>Product</Typography>
                      <TextField disabled sx={{ flex: 0.6 }} name="product" placeholder="Product" />
                      <Typography sx={{ flex: 0.12, fontWeight: 700, fontSize: '1.4rem' }}>Qty</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.07 }}
                        name="Qty"
                        placeholder="Qty"
                        // value={qty}
                        // onChange={handleQtyChange}
                      />
                      <Button
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.1, minWidth: 0, p: 0.1, height: '100%' }}
                        variant="contained"
                        onClick={handleAdd}
                      >
                        Add
                      </Button>
                    </Stack>

                    <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', color: 'red', mt: 1 }}>
                      Stock Qty:- {productRemaining}
                    </Typography>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', boxShadow: '0px 2px 2px #0099ff' }}
                    data={productData}
                    columns={PRODUCT_TABLE_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                    handleDeleteRow={(row) => handleRowDelete(row)}
                    showEditButton={true}
                    onClickEditRow={handleRowEdit}
                  />
                  <Stack direction="row" spacing={0.5} alignItems="center" marginTop={'4%'}>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Total Amt.</Typography>
                      <TextField sx={{ width: '100%' }} name="total_amt" disabled />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 0.8 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Dis%</Typography>
                      <TextField sx={{ width: '100%' }} name="dis_per" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Dis Amt</Typography>
                      <TextField sx={{ width: '100%' }} name="dis_amount" disabled />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Bill Amt</Typography>
                      <TextField sx={{ width: '100%' }} name="bill_amount" inputRef={billAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>GST</Typography>
                      <TextField sx={{ width: '100%' }} name="gst" inputRef={gstAmountRef} disabled />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>CGST</Typography>
                      <TextField sx={{ width: '100%' }} name="cgst" disabled inputRef={cgstAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>SGST</Typography>
                      <TextField sx={{ width: '100%' }} name="sgst" disabled inputRef={sgstAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>1. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_1" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>2. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_2" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Total</Typography>
                      <TextField disabled sx={{ width: '100%' }} name="total_recpt" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Balance</Typography>
                      <TextField disabled sx={{ width: '100%' }} name="balance" />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Retail Sale Pos Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Pos By Invoice No."
            variant="outlined"
            value={posInput}
            onChange={handleChangePos}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_HEADER}
          data={posData.data || []}
          loading={posData.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={opdDialogueOpen}
        onClose={() => setOpdDialogueOpen(false)}
        PaperProps={{ sx: { width: '60%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Opd Patient Details
          </Typography>
          <IconButton onClick={() => setOpdDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" >
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0'
              },
              '& .MuiOutlinedInput-input': {
                padding: '10px 14px'
              }
            }}
            label="Search Patient By Name"
            variant="outlined"
            value={opdInput}
            onChange={handleOpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={OPD_PATIENT_TABLE_COLUMNS}
          data={opdFilterData.data || []}
          loading={opdData.loading}
          onRowClick={(row) => {
            handleOpdPatient(row);
          }}
        />
      </Dialog>
      <Dialog
        open={ipdDialogueOpen}
        onClose={() => setIpdDialogueOpen(false)}
        PaperProps={{ sx: { width: '70%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Patient Details
          </Typography>
          <IconButton onClick={() => setIpdDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0.5 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search Patient By IPDNO or UHID"
            variant="outlined"
            value={ipdInput}
            onChange={handleIpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_TABLE_COLUMNS}
          data={ipdFilterData?.data || []}
          loading={indoorRegisterationDataObj.loading}
          onRowClick={(row) => {
            handleIpdRow(row);
          }}
        />
      </Dialog>
      <Dialog
        open={generalDialogueOpen}
        onClose={() => setGeneralDialogueOpen(false)}
        PaperProps={{ sx: { width: '30%', height: '35vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <GeneralDetailForm
          onClose={() => setGeneralDialogueOpen(false)}
          onAdd={(row) => {
            setPatientDetail((prev) => [...prev, row]);
          }}
        />
      </Dialog>

      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddProductDetailsForm
          onClose={() => setAddDetailsDialogOpen(false)}
          editData={editData}
          isEditMode={isEditMode}
          stock={stock}
          onAdd={onDetailAddHandler}
          setAddDetailsDialogOpen={setAddDetailsDialogOpen}
        />
      </Dialog>
    </>
  );
};
